export const FETCH_CALENDAR_REQUEST = 'FETCH_CALENDAR_REQUEST';
export const FETCH_CALENDAR_SUCCESS = 'FETCH_CALENDAR_SUCCESS';
export const FETCH_CALENDAR_FAILURE = 'FETCH_CALENDAR_FAILURE';
